import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBJqeIaM8tTnUDkJLy5Bbw-TjxRzLgZC7w",
  authDomain: "ranga-banda-theatre.firebaseapp.com",
  projectId: "ranga-banda-theatre",
  storageBucket: "ranga-banda-theatre.appspot.com",
  messagingSenderId: "24615171602",
  appId: "1:24615171602:web:1dfa7f563ecd998ab34acb",
  measurementId: "G-3NW6Y17XYY",
};

const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { auth, firestore, storage };
